import React from 'react';

function TabBar() {
  return (<div className="chrome-tabs-bottom-bar"></div>);
};

export default TabBar;
